import { Check, GripVertical } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { NavItem } from "./navItems";

interface SortableNavItemProps {
  item: NavItem;
  isEditing: boolean;
  isPrimary: boolean;
  onToggle: (path: string) => void;
}

export function SortableNavItem({ item, isEditing, isPrimary, onToggle }: SortableNavItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: item.path,
    disabled: !isEditing,
  });

  const style = { transform: CSS.Transform.toString(transform), transition };
  const Icon = item.icon;

  return (
    <div ref={setNodeRef} style={style}>
      <button
        onClick={() => onToggle(item.path)}
        className={cn(
          "flex w-full items-center gap-3 rounded-lg border p-3 text-left transition-all",
          isPrimary ? "border-primary/50 bg-primary/5" : "border-border hover:bg-muted"
        )}
      >
        {isEditing && isPrimary && (
          <div
            {...attributes}
            {...listeners}
            className="flex-shrink-0 cursor-grab active:cursor-grabbing text-muted-foreground hover:text-foreground"
          >
            <GripVertical className="h-5 w-5" />
          </div>
        )}
        <Icon className={cn("h-5 w-5 flex-shrink-0", isPrimary ? "text-primary" : "text-muted-foreground")} />
        <span className={cn("text-sm font-semibold flex-1", isPrimary ? "text-foreground" : "text-muted-foreground")}>
          {item.label}
        </span>
        <div
          className={cn(
            "h-5 w-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors",
            isPrimary ? "bg-primary border-primary" : "border-muted-foreground/30"
          )}
        >
          {isPrimary && <Check className="h-3 w-3 text-primary-foreground" />}
        </div>
      </button>
    </div>
  );
}
